import {useEffect} from 'react';

import PanelContainer from 'components/PanelContainer';
import {AdobeEvent, useTrackEvent} from 'hooks/useTrackEvent';

export interface OptOutDialogBoxProps {
  onConfirmPress?: () => void;
  onCancelPress?: () => void;
}
const OptoutDialogBox: React.FunctionComponent<OptOutDialogBoxProps> = (
  props,
) => {
  const {onConfirmPress, onCancelPress} = props;

  const {trackAdobeEvent} = useTrackEvent();

  const confirmPressed = () => {
    trackAdobeEvent({
      event: AdobeEvent.click,
      click: {name: 'mfa decline'},
    });
    onConfirmPress && onConfirmPress();
  };

  useEffect(() => {
    trackAdobeEvent({
      event: AdobeEvent.pageLoad,
      page: {name: 'mfa confirm decline'},
    });
  }, []);

  return (
    <PanelContainer
      bodyTextBottomMargin="0"
      title="Are you sure?"
      bodyText="By declining, access to many features of your Caesars Rewards experience will be restricted."
      primaryTitle="Yes, limit my access"
      textLink="Nevermind, secure my account"
      onPrimaryPress={confirmPressed}
      onTextLinkPress={onCancelPress}
      isDialogBox={true}
    />
  );
};

export default OptoutDialogBox;
